import _get from 'lodash/get';
import { trackLink } from '../../lib/analytics-helper';
import * as types from '../constants/ActionTypes';
import { fetchTopicData } from './action-topic-data';
import { fetchRelatedArticle } from './action-related-article';
import fetchChatEligibility from './action-chat';
import Page from '../../lib/page';

function selectTopicResetL1() {
  return {
    type: types.SELECT_TOPIC_L1_RESET,
    payload: undefined,
  };
}

function selectTopicUpdateL1({ subTopic }) {
  return {
    type: types.SELECT_TOPIC_L1,
    payload: subTopic,
  };
}

function selectTopicResetL2() {
  return {
    type: types.SELECT_TOPIC_L2_RESET,
    payload: undefined,
  };
}

function selectTopicUpdateL2(data) {
  return {
    type: types.SELECT_TOPIC_L2,
    payload: data,
  };
}

function selectTopicUpdateL3({ topicId, topicName }) {
  return {
    type: types.SELECT_TOPIC_L3,
    payload: {
      topicId,
      topicName,
    },
  };
}

function selectTopicResult({ topicId, topicName, topicRefId }) {
  return {
    type: types.SELECT_RESULT,
    payload: {
      topicId,
      topicName,
      topicRefId,
    },
  };
}
function selectTopicL1({ subTopic, topicRefId }) {
  return (dispatch, getState) => {
    const preTopicRef = _get(getState(), 'topicTree.topicTreeSelectionL1.ref_id');
    const newTopicRef = _get(subTopic, 'ref_id');
    if (preTopicRef && newTopicRef && preTopicRef !== newTopicRef) {
      trackLink({ id: 'contactUsPage', link: `smarthelp-switch-topic-L1|${newTopicRef}|${preTopicRef}|` });
    }
    trackLink({ id: 'contactUsPage', link: `smarthelp-select-topic-L1|${topicRefId}|` });
    dispatch(selectTopicResetL1());
    dispatch(selectTopicUpdateL1({ subTopic }));
  };
}

// TODO: fetch article data for layer two
function selectTopicL2({ topicId, subTopic, content }) {
  return (dispatch, getStore) => {
    const prevL2 = _get(getStore(), 'topicTree.topicTreeSelectionL2.ref_id');
    let newL2;
    dispatch(selectTopicResetL2());
    if (subTopic && !content) {
      newL2 = subTopic.ref_id;
      trackLink({ id: 'contactUsPage', link: `smarthelp-select-topic-L2|${subTopic.ref_id}|` });
      dispatch(selectTopicUpdateL2(subTopic));
    } else {
      newL2 = content.ref_id;
      trackLink({ id: 'contactUsPage', link: `smarthelp-select-topic-L2|${content.ref_id}|final` });
      dispatch(selectTopicUpdateL2(content));
      // dispatch article search action using topic ID
      dispatch(selectTopicResult({
        topicId: content.topic_id,
        topicName: content.topic_name,
        topicRefId: content.ref_id,
      }));
      if (Page.isLoggedIn()) {
        dispatch(fetchChatEligibility(content.ref_id));
      }
      dispatch(fetchTopicData(topicId));
      dispatch(fetchRelatedArticle(content.topic_name));
    }
    if (prevL2 && newL2 && prevL2 !== newL2) {
      trackLink({ id: 'contactUsPage', link: `smarthelp-switch-topic-L2|${newL2}|${prevL2}` });
    }
  };
}

// TODO: fetch article data for layer three
function selectTopicL3({ topicId, topicName, topicRefId }) {
  return (dispatch, getStore) => {
    const prevL3 = _get(getStore(), 'topicTree.topicTreeSelectionL3.ref_id');
    if (prevL3 && topicRefId) {
      trackLink({ id: 'contactUsPage', link: `smarthelp-switch-topic-L3|${prevL3}|${topicRefId}|final` });
    }
    trackLink({ id: 'contactUsPage', link: `smarthelp-select-topic-L3|${topicRefId}|final` });
    dispatch(selectTopicUpdateL3({ topicId, topicName }));
    // dispatch article search action using topic ID
    dispatch(selectTopicResult({ topicId, topicName, topicRefId }));
    dispatch(fetchTopicData(topicId));
    dispatch(fetchRelatedArticle(topicName));
    if (Page.isLoggedIn()) {
      dispatch(fetchChatEligibility(topicRefId));
    }
  };
}

function selectTopicReset(options) {
  return {
    type: types.SELECT_TOPIC_RESET,
    payload: options,
  };
}

function selectTopic(options) {
  return {
    type: types.SELECT_TOPIC,
    payload: options,
  };
}

module.exports = {
  selectTopicL1,
  selectTopicL2,
  selectTopicL3,
  selectTopicReset,
  selectTopic,
  selectTopicResult,
};
